import imageVehicle from "../images/vehicle-ads.gif";
const projects = [
  {
    type: "front",
    name: "Vehicle Ads",
    description:
      "Site de anúncio de carros onde é possível cadastrar carros com suas informações, os favoritas, bem como fazer um busca de carros em todo o síte",
    src: imageVehicle,
    repository: "https://github.com/carlostsa10/corelab-web-challenge",
    site: "https://vehicle-ads.vercel.app/",
    technologies: ["React", "Context APi", "Hooks", "CSS3", "HTML5", "ES6"],
  },
  {
    type: "front",
    name: "Cobre Bem",
    description:
      "O seu administrador de finanças pessoal e também para empresas.",
    src: "",
    repository: "https://github.com/carlostsa10/cobreBem",
    site: "https://cobre-bem.netlify.app//",
    technologies: ["React", "Context APi", "Hooks", "CSS3", "HTML5", "ES6"],
  },
  /*
  {
    type: 'front', 
    name: 'Trivia', 
    description: 'O trivia é um jogo de perguntas e respostas', 
    src: 'trivia.gif', 
    repository: 'https://github.com/thiagodanobrega/trivia', 
    site: 'https://trivia-thiagodanobrega.vercel.app/', 
    technologies: ['React', 'Redux', 'CSS3', 'HTML5', 'ES6'],
  },
  {
    type: 'front', 
    name: 'Online Store', 
    description: 'Versão simplificada de uma loja online onde é possível buscar e interagir com o produto.', 
    src: 'store.png', 
    repository: 'https://github.com/thiagodanobrega/frontend-online-store', 
    site: 'https://frontend-online-store-thiagodanobrega.vercel.app/', 
    technologies: ['React', 'Redux', 'CSS3', 'HTML5', 'ES6'],
  },
  {
    type: 'back', 
    name: 'Mysql one for all', 
    description: 'Aplicação para treinar conceitos de SQL, como normalização e criação de banco', 
    src: 'back.png', 
    repository: 'https://github.com/thiagodanobrega/mysql-one-for-all', 
    site: 'https://github.com/thiagodanobrega/mysql-one-for-all', 
    technologies: ['MySQL'],
  },
  */
];

export default projects;
